module.exports = __webpack_public_path__ + "static/img/logo_jt.33612da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jt.png
// module id = 3c4K
// module chunks = 0